import React from 'react';
import { iconSize } from './constants.mjs';

const withoutBoundingBoxWidth = {
  large: 22,
  medium: 17,
  small: 12,
  xSmall: 9
};
const PrintIcon = ({ size = "medium", withBoundingBox = true, ...others }) => {
  let iconWidth, iconHeight;
  if (typeof size === "string") {
    iconWidth = withBoundingBox ? iconSize[size] : withoutBoundingBoxWidth[size];
    iconHeight = iconSize[size];
  } else {
    iconWidth = size;
    iconHeight = size;
  }
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      width: iconWidth,
      height: iconHeight,
      viewBox: "0 0 30 30",
      preserveAspectRatio: withBoundingBox ? void 0 : "xMidYMid slice",
      fill: "none",
      ...others
    },
    /* @__PURE__ */ React.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M20.5 6.5V10.5H23.5V18.5H20.5V23.5H9.5V18.5H6.5V10.5H9.5V6.5H20.5ZM7.5 17.5H22.5V11.5H20.5V14.5H9.5V11.5H7.5V17.5ZM19.5 18.5H10.5V22.5H19.5V18.5ZM19.5 7.5V13.5H10.5V7.5H19.5Z",
        fill: "currentColor"
      }
    )
  );
};
PrintIcon.iconName = "PrintIcon";

export { PrintIcon };
